export default "__VITE_ASSET__Cz5OaJGk__"